import { h as o } from "vue";
import { NPerformantEllipsis as t } from "./ghl-ui.es246.js";
const l = (r) => o(t, {}, [r.label]);
export {
  l as renderTooltip
};
